import React from 'react'
import styles from './styles.css'
import {Form, Field} from 'simple-react-form'
import Text from 'orionsoft-parts/lib/components/fields/Text'
import Number from 'orionsoft-parts/lib/components/fields/numeral/Number'
import Textarea from 'orionsoft-parts/lib/components/fields/Textarea'
import Roles from 'App/components/fields/Roles'
import RequiredFiles from 'App/components/fields/RequiredFiles'
import Button from 'orionsoft-parts/lib/components/Button'
import fileUpload from 'App/helpers/fields/fileUpload'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import Toggle from 'orionsoft-parts/lib/components/fields/Toggle'
import gql from 'graphql-tag'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import {withRouter} from 'react-router'
import withOrganization from 'App/Decorators/withOrganization'
import FaUpload from 'react-icons/lib/fa/upload'
import TiInfoOutline from 'react-icons/lib/ti/info-outline'
import MdGroup from 'react-icons/lib/md/group'
import MdPlusOne from 'react-icons/lib/md/plus-one'
import FileUpload from 'react-icons/lib/md/file-upload'
import Face from 'react-icons/lib/md/face'
import FileBinary from 'react-icons/lib/go/file-binary'

@withOrganization
@withMutation(gql`
  mutation createTemplate(
    $name: String
    $description: String
    $signersRoles: [SignersRolesInput]
    $requireRolesOrder: Boolean,
    $feaSignersRoles: [SignersRolesInput]
    $faceSignersRoles: [SignersRolesInput]
    $requiredFiles: [RequiredFilesInput]
    $hasSpectators: Boolean,
    $file: FileInput
    $organizationId: String
    $autoIncremental: Int
  ) {
    createTemplate(
      name: $name
      description: $description
      signersRoles: $signersRoles
      requireRolesOrder: $requireRolesOrder
      feaSignersRoles: $feaSignersRoles
      faceSignersRoles: $faceSignersRoles
      requiredFiles: $requiredFiles
      hasSpectators: $hasSpectators
      file: $file
      organizationId: $organizationId
      autoIncremental: $autoIncremental
    ) {
      _id
    }
  }
`)
@withMessage
@withRouter
export default class Others extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    showMessage: PropTypes.func,
    createTemplate: PropTypes.func,
    organization: PropTypes.objects
  }

  state = {}

  cleanRoles(inRoles){
    let result = [];
    if(inRoles){
      inRoles.forEach(inRole => {
        if(inRole && inRole.name && inRole.name.trim() !== "" )
          result.push(inRole);
      });
    }
    console.log("Result es ", result);
    return result;
  }

  @autobind
  async createTemplate() {
    this.setState({loading: true})
    try {
      let feaSignersRolesToUpload  = this.cleanRoles(this.state.feaSignersRoles); 
      let signersRolesToUpload  = this.cleanRoles(this.state.signersRoles); 
      let faceSignersRolesToUpload  = this.cleanRoles(this.state.faceSignersRoles); 

      const {createTemplate: {_id: templateId}} = await this.props.createTemplate(
        {
          name: this.state.name,
          description: this.state.description,
          signersRoles: signersRolesToUpload,
          requireRolesOrder: this.state.requireRolesOrder,
          feaSignersRoles: feaSignersRolesToUpload,
          faceSignersRoles: faceSignersRolesToUpload,
          requiredFiles: this.state.requiredFiles,
          hasSpectators: this.state.hasSpectators,
          file: this.state.file,
          organizationId: this.props.organization._id,
          autoIncremental: this.state.autoIncremental
        },
        {
          refetcQueries: ['template']
        }
      )
      if(signersRolesToUpload && signersRolesToUpload.length >0 ){
        this.props.router.push(`/sign/prepare/template/${templateId}`)
      } else {
        this.props.router.push(`/templates/${templateId}`)
      }
      
    } catch (error) {
      console.log('Error:', error)
      this.props.showMessage(error.message, {level: 'error'})
    }
    this.setState({loading: false})
  }

  renderSigners() {
    if (this.props.router.location.pathname.endsWith('/me')) return
    return (
      <div className="section">
        <div className="header">
          <div className="row">
            <div className="col-xs-12 col-sm-4">
              <h3 className={styles.title}>Qué roles necesitan firmar</h3>
            </div>
            <div className="col-xs-12 col-sm-8 end-md">
              <div className={styles.icon}>
                <MdGroup size={18} />
              </div>
            </div>
          </div>
        </div>
        <div className="content">
          <div className="requireRole isrequired"></div>
          <Field fieldName="signersRoles" 
            type={Roles} 
            draggable={this.state.requireRolesOrder}
          />

            <div>
              <br />{' '}
              <Field
                fieldName="requireRolesOrder"
                type={Toggle}
                label="Los roles tienen un orden"
              />
            </div>

            <div>
              <br />{' '}
              <Field
                fieldName="hasSpectators"
                type={Toggle}
                label="Documento tiene espectadores"
              />
            </div>

        </div>
      </div>
    )
  }

  renderRolRepetido() {
    if(this.tieneRolRepetido())
    return (
      <div>Un mismo rol no puede estar en más de una sección</div>
    )
  }xw

  renderFeaSigners() {
    if (this.props.router.location.pathname.endsWith('/me')) return
    return (
      <div className="section">
        <div className="header">
          <div className="row">
            <div className="col-xs-12 col-sm-10">
              <h3 className={styles.title}>Qué roles necesitan firmar con firma avanzada</h3>
            </div>
            <div className="col-xs-12 col-sm-2 end-md">
              <div className={styles.icon}>
                <FileBinary size={18} />
              </div>
            </div>
          </div>
        </div>
        <div className="content">
          <div className="requireFeaRole isrequired"></div>
          <Field fieldName="feaSignersRoles" 
            type={Roles} 
          />
        </div>
      </div>
    )
  }

  renderFaceSigners() {
    if (this.props.router.location.pathname.endsWith('/me')) return

    return (
      <div className="section">
        <div className="header">
          <div className="row">
            <div className="col-xs-12 col-sm-10">
              <h3 className={styles.title}>Qué roles necesitan firma facial</h3>
            </div>
            <div className="col-xs-12 col-sm-2 end-md">
              <div className={styles.icon}>
                <Face size={18} />
              </div>
            </div>
          </div>
        </div>
        <div className="content">
          <div className="requireFaceRole isrequired"></div>
          <Field fieldName="faceSignersRoles" 
            type={Roles} 
          />
        </div>
      </div>
    )
  }

  tieneRolRepetido() {
    console.log("tieneRolRepetido");
    let arrayConTodos = [];
    let soloRoles = [];

    //console.log("SignersRoles", this.state.signersRoles);
    arrayConTodos = arrayConTodos.concat(this.state.signersRoles);
    arrayConTodos = arrayConTodos.concat(this.state.feaSignersRoles);
    arrayConTodos = arrayConTodos.concat(this.state.faceSignersRoles);
    //console.log("Completo es: ", arrayConTodos);

    if(arrayConTodos.length > 0){
      for (const rol of arrayConTodos) {
        if(!rol || !rol.name){
          //console.log("Aca no hay nada: ", rol);
          continue;
        }
        if(soloRoles.includes(rol.name)){
          //console.log("Ya tengo!!!! " + rol.name);
          return true;
        } else {
          soloRoles.push(rol.name);
        }
      }
    }
    return false;
  }

  checkForm() {
    let value = true    
    let signersCheck = [];
    let feaSignersCheck = [];
    let faceSignersCheck = [];

    let sinRolRepetido = !this.tieneRolRepetido();

    if(this.state.signersRoles){
      this.state.signersRoles.forEach(signerRole => {
        
        if(signerRole && signerRole.name && signerRole.name.trim().length > 0){
          console.log("Cumple");
          signersCheck.push(signerRole);
        }
      });
    }
    if(this.state.feaSignersRoles){
      this.state.feaSignersRoles.forEach(feaSignersRole => {
        if(feaSignersRole && feaSignersRole.name && feaSignersRole.name.trim().length > 0)
          feaSignersCheck.push(feaSignersRole);
      });
    }
    if(this.state.faceSignersRoles){
      this.state.faceSignersRoles.forEach(faceSignerRole => {
        if(faceSignerRole && faceSignerRole.name && faceSignerRole.name.trim().length > 0)
          faceSignersCheck.push(faceSignerRole);
      });
    }

    //console.log("signersCheck", signersCheck);
    //console.log("feaSignersCheck", feaSignersCheck);

    let signerValue=true;
    let feaSignerValue=true;
    let faceSignerValue=true;

    for (const signer of signersCheck) {
      if (!signer.name) {
        signerValue = false
        break
      }
    }
    
    for (const feaSigner of feaSignersCheck) {
      if (!feaSigner.name) {
        feaSignerValue = false
        break
      }
    }
    for (const faceSigner of faceSignersCheck) {
      if (!faceSigner.name) {
        faceSignerValue = false
        break
      }
    }
    //console.log("signer y feaSigner values: " + signerValue + "-" + feaSignerValue);
    value = signerValue && feaSignerValue && faceSignerValue && sinRolRepetido;
    if(faceSignersCheck.length + signersCheck.length + feaSignersCheck.length === 0)
      value = false;
      
    console.log("value ahora: " + value);
    
    
    const requiredFilesCheck = this.state.requiredFiles || []
    for (const requiredFile of requiredFilesCheck) {
      if (!requiredFile.name) {
        value = false
        break
      }
    }
    const checkFile = document.querySelector('.requireFile');
    const checkName = document.querySelector('.requireName');
    const checkRole = document.querySelector('.requireRole')
    const checkFeaRole = document.querySelector('.requireFeaRole')
    const msgbox = document.querySelector('.messagePDF');


    const check=(element,data)=>{
      if(element){      
        if(data){
          element.classList.remove('active');
        }else{
          element.classList.add('active');
        }
      }
    }
    const check2=(element,data,checkRoleSigner)=>{
      if(element){      
        if(data && checkRoleSigner === true){
          element.classList.remove('active');
        }else{
          element.classList.add('active');
        }
      }
    }
    const checkmsg=()=>{
      if(msgbox){
        if(this.state.file){
          if(this.state.file.bool === false){
            msgbox.style.display="block";
          }
        }else{
          msgbox.style.display="none";
        }
      }
    }
    const copyName=()=>{
      if(this.state.file){
        if(this.state.name === undefined){
          this.setState({
            name: this.state.file.nameFile.replace(/([\.][^.]+)?$/,'')
          })
        }
      }
    }

    check(checkFile,this.state.file)
    check(checkName,this.state.name)
    check2(checkRole,this.state.signersRoles, signerValue)
    check2(checkFeaRole,this.state.feaSignersRoles, feaSignerValue)
    checkmsg()
    copyName()

    return !this.state.file || !value || !this.state.name
  }

  render() {
    return (
      <div className={styles.container}>
        <Form state={this.state} onChange={changes => this.setState(changes)}>
          <div className="section">
            <div className="header">
              <div className="row">
                <div className="col-xs-12 col-sm-3">
                  <h3 className={styles.title}>Carga el documento</h3>
                </div>
                <div className="col-xs-12 col-sm-9 end-md">
                  <div className={styles.icon}>
                    <FaUpload size={18} />
                  </div>
                </div>
              </div>
            </div>
            <div className="content">
            <div className="requireFile isrequired"></div>
              <Field fieldName="file" label="File" {...fileUpload} />
              <div className='messagePDF'>Puede ser que se generen diferencias en los formatos Word, Excel y PowerPoint. Sugerimos de preferencia que sea en formato PDF</div>
            </div>
          </div>
          <div className="section">
            <div className="header">
              <div className="row">
                <div className="col-xs-12 col-sm-4">
                  <h3 className={styles.title}>Información del template</h3>
                </div>
                <div className="col-xs-12 col-sm-8 end-md">
                  <div className={styles.icon}>
                    <TiInfoOutline size={20} />
                  </div>
                </div>
              </div>
            </div>
            <div className="content">
              <div className="label requireName isrequired">Nombre</div>
              <Field fieldName="name" placeholder="Nombre" type={Text} />
              <br />
              <div className="label">Descripción (opcional)</div>
              <Field fieldName="description" placeholder="Descripción" type={Textarea} />
            </div>
          </div>

          <div className="section">
            <div className="header">
              <div className="row">
                <div className="col-xs-12 col-sm-2">
                  <h3 className={styles.title}>Correlativo</h3>
                </div>
                <div className="col-xs-12 col-sm-10 end-md">
                  <div className={styles.icon}>
                    <MdPlusOne size={20} />
                  </div>
                </div>
              </div>
            </div>
            <div className="content">
              <div className="label">Número inicial</div>
              <Field fieldName="autoIncremental" placeholder="Número" type={Number} />
              <br />
            </div>
          </div>

          <div className="section">
            <div className="header">
              <div className="row">
                <div className="col-xs-12 col-sm-10">
                  <h3 className={styles.title}>Adjuntos necesarios</h3>
                </div>
                <div className="col-xs-12 col-sm-2 end-md">
                  <div className={styles.icon}>
                    <FileUpload size={20} />
                  </div>
                </div>
              </div>
            </div>
            <div className="content">
              <Field fieldName="requiredFiles" 
                type={RequiredFiles} 
                draggable={this.state.requiredFiles}
              />
            </div>
          </div>

          {this.renderSigners()}
          {this.renderRolRepetido()}
          { this.renderFeaSigners() }
          { // this.renderFaceSigners() 
          }
        </Form>
        <div className="right-align">
          <Button
            disabled={this.checkForm()}
            onClick={this.createTemplate}
            loading={this.state.loading}
            primary
          >
            Preparar el documento
          </Button>
        </div>
        <br />
        <br />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Templates/Create/index.js